import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import PropTypes from 'prop-types';

class ConfirmModal extends Component {
  static propTypes ={
    isOpened: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    headerText: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
    confirmBtnText: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isOpened}
          className="modal-danger"
        >
          <ModalHeader>{this.props.headerText}</ModalHeader>
          <ModalBody>
            {this.props.bodyText}
          </ModalBody>
          <ModalFooter>
            <Button id="confirm-modal-btn" color="danger" onClick={this.props.onConfirm}>{this.props.confirmBtnText}</Button>{' '}
            <Button id="cancel-modal-btn" color="secondary" onClick={this.props.onCancel}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/Alerts/ConfirmModal.js